import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { StringMap } from '@app/utils/string-map';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(
    private datePipe: DatePipe,
    private translateService: TranslateService
  ) {}

  saveAsFile(content: string, name: string, fileNameParameters: StringMap<string> = {}): void {
    // For some reason UTF-8 BOM is not added, cf. https://redmine.neotel.at/issues/40072
    // Current used version of FileSaver is v2.0.2
    // Looking at the code of FileSaver this should only work if (the browser) `navigator.msSaveOrOpenBlob` has that function.
    // Meaning, the BOM is added only when using some Microsoft Browser ... (why?)
    // Maybe this will be changed in the future of FileSaver.js; Until then we will set the BOM explicitly.

    const saveWithAutoBom = {
      autoBom: false,
      // autoBom: true
    };

    // Adding BOM explicitly (value `0xFEFF` will be automatically set to `0xEFBBBF` by the browser)
    const blob = new Blob([String.fromCharCode(0xfeff), content], {
      type: 'text/csv;charset=utf-8',
    });

    const parameters = {
      ...fileNameParameters,
      date: this.datePipe.transform(new Date(), 'yyyy-MM-dd_HH-mm-ss'),
    };

    const fileName = this.translateService.instant(name, parameters);

    saveAs(blob, fileName, saveWithAutoBom);
  }
}
